import ClientsAxios from '../client-axios';
import { TokenRequest } from '../dto/request';
import { DemoAndPriceEnquiryRequest } from '../dto/request/chat';
import { ResponseEntity, TokenResponse } from '../dto/response';
import { DemoAndPriceEnquiryResponse, FetchAddResponse, TractorApiResponse, TractorData } from '../dto/response/chat';

const { API_SERVER } = ClientsAxios;

export const tokenService = async (formData: FormData) => {
    const responseEntity = new ResponseEntity<TokenResponse>()
    try {
        const response = await API_SERVER.post('token', formData, {
            headers: {
                "content-Type": "multipart/form-data",
            },
        });
        responseEntity.success(response.data.body, 200, response.data.message)

    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchChatService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<TractorData>()
    try {
        const response = await API_SERVER.post('/chat', payload, { signal })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchAddService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<FetchAddResponse>()
    try {
        const response = await API_SERVER.get('/ads/images', payload, { signal })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchDropdownService = async (payload: any, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('/dropdown', payload, { signal })        
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}


export const RequestDemoEnquiryService = async (payload: DemoAndPriceEnquiryRequest, signal?: AbortSignal) => {
    const responseEntity = new ResponseEntity<DemoAndPriceEnquiryResponse>()
    try {
        const response = await API_SERVER.post('/enquiry', payload, signal)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}